module.exports = __webpack_public_path__ + "static/media/power.f18ade3a.svg";